import React from 'react';
import { Link } from 'react-router-dom';

import useSharedStyles from '../theme/pbdqShared.styles';
import pbdqRoutes from '../pbdqRoutes';
import { useAgentChat } from './PbdqAgentChatContext';
import LogoFooter from '../../../assets/images/PoweredByDQ/LogoFooter.png';

// The source mockup's footer is identical on every page except "Get Started",
// whose second column is retitled "Get started" with different links —
// confirmed directly against the source (all 13 pages checked), not a bug.
const PbdqFooter = ({ variant = 'default' }) => {
    const classes = useSharedStyles();
    const openAgentChat = useAgentChat();

    return (
        <footer className={classes.footer}>
            <div className={classes.footerInner}>
                <div className={classes.footerGrid}>
                    <div>
                        <img src={LogoFooter} alt="Powered by DQ logo" className={classes.footerLogo} />
                        <p className={classes.footerBlurb}>
                            Powered by DQ is the AI-enabled engine behind AI-digital literacy systems worldwide — built
                            on IEEE 3527.1™, the global standard for digital intelligence, and aligned with 1,000+
                            national and international frameworks and programs.
                        </p>
                    </div>
                    <div className={classes.footerCol}>
                        <span className={classes.footerColTitle}>Solutions</span>
                        <Link to={pbdqRoutes.cosAssessments} className={classes.footerLink}>COS Assessments</Link>
                        <Link to={pbdqRoutes.schoolCosReadiness} className={classes.footerLink}>School COS Readiness</Link>
                        <Link to={pbdqRoutes.learnCreator} className={classes.footerLink}>LearnCreator</Link>
                        <Link to={pbdqRoutes.workforceAiReadiness} className={classes.footerLink}>Workforce AI Readiness</Link>
                        <Link to={pbdqRoutes.programValidation} className={classes.footerLink}>Program Validation</Link>
                        <Link to={pbdqRoutes.dqEveryChild} className={classes.footerLink}>#DQEveryChild</Link>
                    </div>
                    {variant === 'getStarted' ? (
                        <div className={classes.footerCol}>
                            <span className={classes.footerColTitle}>Get started</span>
                            <Link to={pbdqRoutes.getStarted} className={classes.footerLink}>Pricing &amp; solutions</Link>
                            <Link to={`${pbdqRoutes.getStarted}#calculator`} className={classes.footerLink}>Price calculator</Link>
                            <Link to={pbdqRoutes.pricing} className={classes.footerLink}>Become a DQ Pro</Link>
                            <Link to={`${pbdqRoutes.pricing}#calculator`} className={classes.footerLink}>Partner opportunity calculator</Link>
                        </div>
                    ) : (
                        <div className={classes.footerCol}>
                            <span className={classes.footerColTitle}>Partners</span>
                            <Link to={pbdqRoutes.pricing} className={classes.footerLink}>Become a DQ Pro</Link>
                            <Link to={`${pbdqRoutes.pricing}#calculator`} className={classes.footerLink}>Opportunity calculator</Link>
                            <Link to={`${pbdqRoutes.pricing}#apply`} className={classes.footerLink}>How to start</Link>
                            <Link to={`${pbdqRoutes.pricing}#apply`} className={classes.footerLink}>Apply to become a DQ Pro</Link>
                            <Link to={pbdqRoutes.getStarted} className={classes.footerLink}>Pricing &amp; solutions</Link>
                        </div>
                    )}
                    <div className={classes.footerCol}>
                        <span className={classes.footerColTitle}>Company</span>
                        <Link to={pbdqRoutes.impact} className={classes.footerLink}>Impact</Link>
                        <Link to={pbdqRoutes.capabilities} className={classes.footerLink}>Capabilities</Link>
                        <button type="button" onClick={openAgentChat} className={classes.footerLink} style={{ background: 'none', border: 0, padding: 0, font: 'inherit', textAlign: 'left',color:'#ffffffd9', cursor: 'pointer' }}>Talk to the DQ Agent</button>
                        <a href="https://app.poweredbydq.com/login" className={classes.footerLink}>Log in</a>
                        <a href="https://www.dqinstitute.org" className={classes.footerLink}>About</a>
                    </div>
                </div>
                <p className={classes.footerLegal}>
                    © 2026 DQ Institute and DQ Lab Pte Ltd. All rights reserved. · Privacy · Terms · Child data protection · Accessibility
                </p>
            </div>
        </footer>
    );
};

export default PbdqFooter;
